export default "__VITE_ASSET__dfa70a42__"